import SalarieDateHandicap from '@/generated/controls/salarie/SalarieDateHandicap.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieDateHandicap
})
